import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "hideContent", "hideIcon", "onClick", "isDisabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useCallback } from 'react';
import * as Actions from '../../../actions';
var ActionGroupItem = function ActionGroupItem(_ref) {
  var item = _ref.item,
    size = _ref.size,
    appearance = _ref.appearance,
    asDropDownItems = _ref.asDropDownItems,
    onActionItemClick = _ref.onActionItemClick;
  var name = item.name,
    hideContent = item.hideContent,
    hideIcon = item.hideIcon,
    onClick = item.onClick,
    isDisabled = item.isDisabled,
    props = _objectWithoutProperties(item, _excluded);
  var handleOnClick = useCallback(function () {
    if (onActionItemClick) {
      onActionItemClick();
    }
    if (onClick) {
      onClick();
    }
  }, [onActionItemClick, onClick]);
  var Action = Actions[name];
  if (!Action) {
    return null;
  }
  var actionProps = _objectSpread({}, props);
  if (hideContent && !asDropDownItems) {
    actionProps.content = '';
  }
  if (hideIcon) {
    actionProps.icon = undefined;
  }
  return jsx(Action
  // Remove url once ViewAction is retired.
  // This seems to be a typescript workaround
  // because ViewAction marks it as required,
  // which does not reflect actual implementation as the url
  // came from data context and not all actions require url.
  // https://product-fabric.atlassian.net/browse/EDM-9547
  , _extends({
    url: "",
    asDropDownItem: asDropDownItems,
    size: size,
    appearance: appearance,
    onClick: handleOnClick,
    isDisabled: isDisabled
  }, actionProps));
};
export default ActionGroupItem;